import { FormControl, ValidationErrors } from '@angular/forms';

export function blankStringValidator(formControl: FormControl): ValidationErrors | null {
  const result = /^\s*$/.test(formControl.value);
  return result ? { blank: true } : null;
}
